enum BookingRoleStatus {
	Active = 90,
	Cancelled = 100,
}

export default BookingRoleStatus;